__turbopack_context__.v({
  "body": "index-module__frUbQW__body",
  "bonus": "index-module__frUbQW__bonus",
  "description": "index-module__frUbQW__description",
  "divider": "index-module__frUbQW__divider",
  "dividerText": "index-module__frUbQW__dividerText",
  "footer": "index-module__frUbQW__footer",
  "header": "index-module__frUbQW__header",
  "inner": "index-module__frUbQW__inner",
  "link": "index-module__frUbQW__link",
  "popular": "index-module__frUbQW__popular",
  "price": "index-module__frUbQW__price",
  "priceBox": "index-module__frUbQW__priceBox",
  "root": "index-module__frUbQW__root",
  "tooltip": "index-module__frUbQW__tooltip",
});
